import Accordion from 'react-bootstrap/Accordion';
import './pada.css';

function Pada() {
  const years = [2026, 2025, 2024, 2023, 2022];

  function generateLinks(year) {
    const links = [
      {
        label: 'Programa de Desarrollo Archivistivo',
        url: `https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/pada/${year}/PADA_${year}.pdf`,
      },
      {
        label: 'Informe de Cumplimiento Anual',
        url: `https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/pada//${year}/Inf_Anual_PADA_${year}.pdf`,
      },
    ];

    return links.map((link, index) => (
      <div key={index} className="accordion-text-container">
        <p>{link.label}</p>
        <a href={link.url} download>
          <button>PDF</button>
        </a>
      </div>
    ));
  }

  return (
    <div>
      <div className="title-container">
        <h1 className="title">Programa Anual de Desarrollo Archivistico</h1>
      </div>
      <div className="accordion-container">
        <Accordion>
          {years.map((year) => (
            <Accordion.Item key={year} eventKey={year}>
              <Accordion.Header className="accordion-header">
                PADA {year}
              </Accordion.Header>
              <Accordion.Body className="accordion-body">
                {generateLinks(year)}
              </Accordion.Body>
            </Accordion.Item>
          ))}
        </Accordion>
      </div>
    </div>
  );
}
export default Pada;

